'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnderlineTab = exports.DividerTab = exports.DefaultTab = exports.Tabs = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 14px;\n  line-height: ', 'px;\n  ', '\n  ', '\n  ', '\n  justify-content: ', ';\n'], ['\n  display: inline-block;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 14px;\n  line-height: ', 'px;\n  ', '\n  ', '\n  ', '\n  justify-content: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  float: left;\n  cursor: pointer;\n  font-family: ', ';\n  margin-right: 16px;\n  color: ', ';\n  ', '\n  ', '\n  transition-duration: .3s;\n  transition-property: opacity, color;\n  opacity: 0.8;\n\n  ', '\n\n  &:hover {\n    opacity: 1;\n  }\n'], ['\n  float: left;\n  cursor: pointer;\n  font-family: ', ';\n  margin-right: 16px;\n  color: ', ';\n  ', '\n  ', '\n  transition-duration: .3s;\n  transition-property: opacity, color;\n  opacity: 0.8;\n\n  ', '\n\n  &:hover {\n    opacity: 1;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 0 16px;\n  border-right: 1px solid ', ';\n\n  &:last-child {\n    border-right: none;\n    padding-right: 0;\n  }\n'], ['\n  margin: 0;\n  padding: 0 16px;\n  border-right: 1px solid ', ';\n\n  &:last-child {\n    border-right: none;\n    padding-right: 0;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-bottom: 2px solid transparent;\n  transition-property: opacity, color, border-color;\n\n  ', '\n'], ['\n  border-bottom: 2px solid transparent;\n  transition-property: opacity, color, border-color;\n\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Tabs = exports.Tabs = _styledComponents2.default.ul(_templateObject, function (props) {
  return props.lineHeight;
}, (0, _helpers.boolStyle)('large', 'font-size: 18px; line-height: 40px;'), (0, _helpers.boolStyle)('right', 'float: right;'), (0, _helpers.boolStyle)('center', 'display: flex; justify-content: space-around;'), function (props) {
  return props.stretchHorizontal ? 'space-between' : 'space-around';
});

Tabs.displayName = 'Tabs';
var DefaultTab = exports.DefaultTab = _styledComponents2.default.li(_templateObject2, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color[props.variant];
}, (0, _helpers.boolStyle)('large', 'margin-right: 60px;'), (0, _helpers.boolStyle)('center', '&:last-child { margin-right: 0; }'), function (props) {
  return props.active && '\n    opacity: 1;\n  ';
});

DefaultTab.displayName = 'DefaultTab';
var DividerTab = exports.DividerTab = (0, _styledComponents2.default)(DefaultTab)(_templateObject3, function (props) {
  return props.theme.color.base3;
});

DividerTab.displayName = 'DividerTab';
var UnderlineTab = exports.UnderlineTab = (0, _styledComponents2.default)(DefaultTab)(_templateObject4, function (props) {
  return props.active && '\n    border-bottom-color: ' + props.theme.color[props.variant] + ';\n  ';
});
UnderlineTab.displayName = 'UnderlineTab';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tabs/styles.js
// module id = 3041
// module chunks = 4